<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-14 14:23:53
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-11-09 17:06:11
 * @name: 系列添加或编辑
 * @Description: 系列添加或编辑
 * @FilePath: \preSaleNafterSaleBackstage\src\components\modelGoodsManage\dialog\addNedit-series.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <addNeditDialog ref="addNeditDialog" :title="title[titleIndex]">
    <template v-slot:form>
      <div class="line">
        <font class="label">所属品牌:</font>
        <el-select
          class="input"
          v-model="form.parent_id"
          placeholder="请选择所属品牌"
        >
          <el-option
            v-for="item of modelGoods.options_brand"
            :key="item.id"
            :label="item.category_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="line">
        <font class="label"><i class="warn">*</i>系列名称:</font>
        <el-input
          class="input"
          v-model="form.name"
          placeholder="请输入系列名称"
        ></el-input>
      </div>
      <div class="line">
        <font class="label">状态:</font>
        <el-radio-group v-model="form.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </div>
    </template>
    <template v-slot:btnGroup>
      <el-button class="submit" type="primary" @click="submit">提交</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import { debounceation } from "@/utils/decorator";
import addNeditDialog from "./addNeditDialog.vue";
export default {
  name: "modelGoodsManage-addNeditSeries",
  components: {
    addNeditDialog,
  },
  props: {
    modelGoods: {
      type: Object,
    },
  },
  data() {
    return {
      title: ["添加系列", "编辑系列"], //标题可选数组
      titleIndex: 0, //标题选择序号
      category_id: "", //系列id
      form: {
        //表单数据
        parent_id: "", // 所属品牌id
        name: "", //系列名称
        status: true, //系列状态
      },
    };
  },
  computed: {
    // 验证系列名是否已填
    name_match() {
      return !this.form.name;
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗,编辑状态赋初始值
     * @param {Object | undefind} form 品牌原数据 | 未传
     */
    open(form) {
      let {
        id: category_id,
        category_name: name,
        status,
      } = form || { id: "", category_name: "", status: 1 }; //传了值赋值,未传值赋默认值
      this.category_id = category_id; //赋值id
      this.form = { name, status }; //赋值表单数据
      this.titleIndex = category_id ? 1 : 0; //判断是否有id,有即编辑,否则为添加
      this.getOptionsBrand();
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取品牌选择框数组
     */
    getOptionsBrand() {
      this.modelGoods.getOptionsBrand({ limit: 10000 }).then((res) => {
        //赋默认值,判断默认值是否在可选数组内存在
        if (
          this.modelGoods.options_brand.findIndex(
            (x) => x.id === this.modelGoods.table_series_data.id
          ) > -1
        ) {
          this.$set(
            this.form,
            "parent_id",
            this.modelGoods.table_series_data.id
          );
        }
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击提交,判断是否有id,有即编辑,否则为添加
     */
    @debounceation(300)
    submit() {
      this.category_id &&
        this.$emit("edit", { category_id: this.category_id, ...this.form });
      this.category_id || this.$emit("add", this.form);
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 100%;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .input {
    flex: 1;
  }
}
.submit {
  width: $Var-button-width-normal;
}
</style>
